const state = () => ({
  headerSearchCollections: [],
  headerSearchWineClubs: [],
  headerSearchLinks: [],
  headerSearchExecuting: false,
  headerSearchOpen: false,
  headerSearchResults: [],
  headerSearchCount: 0,
  headerIsSingleCollectionResults: false,
})

const mutations = {
  SET_HEADER_SEARCH_OPEN(state, value) {
    state.headerSearchOpen = value
  },
  CLEAR_HEADER_SEARCH(state) {
    state.headerSearchCollections = []
    state.headerSearchWineClubs = []
    state.headerSearchLinks = []
    state.headerSearchExecuting = false
    state.headerSearchResults = []
    state.headerSearchCount = 0
    state.headerSearchOpen = false
    state.headerIsSingleCollectionResults = false
  },
  SET_IS_SINGLE_COLLECTION_RESULTS(state) {
    state.headerIsSingleCollectionResults = true
  },
  BEFORE_SEARCH(state) {
    state.headerSearchExecuting = true
    state.headerIsSingleCollectionResults = false
  },
  SET_FROM_API_RESPONSE(state, resp) {
    if (resp.data === 'no data') {
      state.headerSearchCount = 0
      state.headerSearchExecuting = false
      return []
    }
    state.headerSearchResults = resp.data.results
    state.headerSearchCollections = resp.data.collections
    if (resp.data.links !== undefined) {
      state.headerSearchWineClubs = resp.data.links.filter(
        (l) => l.collection_type === 'membershiptype',
      )
      state.headerSearchLinks = resp.data.links.filter(
        (l) => l.collection_type === 'link',
      )
    }
    state.headerSearchCount = resp.data.count
    state.headerSearchExecuting = false
  },
}

const actions = {
  setHeaderSearchOpen({ commit }, value) {
    commit('SET_HEADER_SEARCH_OPEN', value)
  },
  clearHeaderSearch({ commit }) {
    commit('CLEAR_HEADER_SEARCH')
    commit('SET_ANY_SEARCH_EXECUTING', false, { root: true })
  },
  async searchAndUpdateState({ commit }, params) {
    commit('BEFORE_SEARCH')
    let response = await this.$axios.get('/api/catalog/search/', { params })
    if (
      response.data.results.length === 0 &&
      response.data.collections.length === 1
    ) {
      // If there are no product results and only one collection, show this
      // collection and this collection's products
      params = {
        occasions__in: response.data.collections[0].slug,
      }
      response = await this.$axios.get('/api/catalog/search/', { params })
      commit('SET_IS_SINGLE_COLLECTION_RESULTS')
    }
    commit('SET_FROM_API_RESPONSE', response)
  },
  executeHeaderSearch({ commit, dispatch, getters, rootState }, query) {
    const params = {
      search: query,
    }
    if (query.length > 2) {
      commit('SET_ANY_SEARCH_EXECUTING', true, { root: true })
      dispatch('searchAndUpdateState', params)
      commit('SET_ANY_SEARCH_EXECUTING', false, { root: true })
    } else {
      commit('CLEAR_HEADER_SEARCH')
    }
  },
}

const getters = {
  headerSearchCollections(state) {
    return state.headerSearchCollections
  },
  headerSearchWineClubs(state) {
    return state.headerSearchWineClubs
  },
  headerSearchLinks(state) {
    return state.headerSearchLinks
  },
  headerSearchExecuting(state) {
    return state.headerSearchExecuting
  },
  headerSearchOpen(state) {
    return state.headerSearchOpen
  },
  headerSearchResults(state) {
    return state.headerSearchResults
  },
  headerSearchCount(state) {
    return state.headerSearchCount
  },
  headerIsOnlyCollectionResults(state) {
    return (
      state.headerSearchCollections.length > 0 &&
      state.headerSearchResults.length < 1
    )
  },
  getHeaderStoreSearchUrl:
    (state, getters) =>
    (query, validateResults = true) => {
      const url = `/store/search/${query}/?ordering=-score`

      if (!validateResults) {
        return url
      }

      if (
        state.headerIsSingleCollectionResults ||
        getters.headerIsOnlyCollectionResults
      ) {
        return state.headerSearchCollections[0].url
      } else if (query && state.headerSearchResults.length > 0) {
        return `/store/search/${query}/?ordering=-score`
      }
      return '/store/'
    },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
